import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { _throw as ObservableThrow } from 'rxjs/observable/throw';
import { ContactStatusBgColorSettingResource } from '@blcloud/bl-ng-resource';
import { IContactStatusBgColorSetting } from '@blcloud/bl-datamodel';
import { BlApiErrorInfo, HttpStatus } from '@blcloud/bl-ng-common';
import { LoginResourceService } from '@blcloud/bl-ng-share-module';
import { of as ObservableOf } from 'rxjs/observable/of';


/**
 * コンタクト状況背景色設定サービス
 */
@Injectable()
export class ContactBgColorSettingModalService {

  /**
   * コンストラクタ
   * @param
   */
  constructor(
    private loginResourceService: LoginResourceService,
    private contactStatusBgColorSettingResource: ContactStatusBgColorSettingResource,
  ) {
  }

  /**
   * コンタクト状況別背景色設定取得
   */
  getContactStatusBgColorSetting(): Observable<IContactStatusBgColorSetting> {
    let organizationCode;

    return this.loginResourceService.getLoginUserEmployeeBindModel().pipe(
      mergeMap(loginUser => {
        organizationCode = loginUser.organizationCode;
        return this.contactStatusBgColorSettingResource.getById<IContactStatusBgColorSetting>(organizationCode);
      }),
      catchError((error: BlApiErrorInfo) => {
        if (error.status === HttpStatus.NotFound) {
          return ObservableOf(null);
        } else {
          return ObservableThrow(error);
        }
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/contact-bg-color-setting/contact-bg-color-setting-modal.service.ts